var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0617 23.6191C36.632 23.3625 36.7315 22.7226 37.1835 22.5616L42.0785 20.7377C42.2733 20.675 42.4277 20.5059 42.4609 20.2926L43.7127 15.1725C43.8342 14.6658 44.4516 14.5399 44.7453 14.939L47.8112 19.0183C47.9287 19.178 48.1271 19.2752 48.3292 19.257L53.4808 18.7117C53.9732 18.6572 54.2705 19.2162 53.9947 19.6166L50.998 23.968C50.8877 24.1282 50.8545 24.3414 50.9353 24.5545L52.8655 29.3472C53.0527 29.7909 52.6335 30.2894 52.156 30.1573L47.2332 28.7742C47.0421 28.7214 46.8216 28.7663 46.6856 28.9088L42.7451 32.374C42.3665 32.7036 41.7787 32.4562 41.7863 31.9498L41.7448 26.7262C41.7339 26.5219 41.6348 26.3356 41.4805 26.2293L37.0617 23.6191Z",
    fill: "#FFC71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3697 27.2546C46.7452 27.0606 46.0654 27.2221 45.5691 27.6675L42.8012 30.0905L42.7699 26.4482C42.774 25.7819 42.4252 25.1875 41.8669 24.8423L38.8329 23.0284L42.2469 21.7587C42.6364 21.6334 42.9783 21.3572 43.2173 21.0102C43.3643 20.7966 43.4673 20.592 43.5189 20.3521L44.3878 16.7787L46.5211 19.6253C46.925 20.1396 47.5385 20.4047 48.1889 20.341L51.7751 19.9771L49.6793 23.0204C49.2932 23.581 49.201 24.2652 49.4616 24.8776L50.8083 28.2059L47.3697 27.2546Z",
    fill: "url(#paint0_linear_17108_263524)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5592 42.5341C39.2864 41.966 39.8357 41.3634 40.4222 41.5086L43.0015 42.1225C43.2495 42.1921 43.5292 42.1218 43.7123 41.921L45.6693 40.1157C46.1491 39.6682 46.8847 39.9652 46.9157 40.5884L47.0837 43.1906C47.0961 43.4398 47.2367 43.6798 47.4616 43.8012L49.8006 45.0204C50.3555 45.3055 50.2791 46.099 49.7112 46.3277L47.2125 47.3341C46.9853 47.4256 46.8022 47.6265 46.7389 47.9062L46.2362 50.4818C46.1242 51.0779 45.3376 51.3099 44.9281 50.8392L43.2457 48.8469C43.0819 48.6587 42.8191 48.5526 42.5773 48.6076L39.9046 48.9636C39.278 49.0464 38.8329 48.3782 39.1929 47.8518L40.6267 45.6216C40.7572 45.3995 40.7827 45.135 40.6946 44.9162L39.5592 42.5341Z",
    fill: "#FFC71B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6826 48.4802C43.9453 47.6329 42.8566 47.2238 41.6937 47.3955L40.8253 47.5334L41.3158 46.7849C41.9369 45.8143 42.0326 44.6316 41.5457 43.6411L41.1847 42.8542L42.0571 43.0538C42.734 43.2049 43.4657 43.1645 44.1093 42.9053C44.4879 42.7528 44.875 42.5122 45.157 42.2291L45.7967 41.6324L45.8401 42.5049C45.8959 43.6266 46.5489 44.5925 47.5534 45.1203L48.3331 45.5267L47.5002 45.8621C46.4402 46.2891 45.6614 47.196 45.446 48.2998L45.256 49.1391L44.6826 48.4802Z",
    fill: "url(#paint1_linear_17108_263524)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5047 26.7119C18.5263 26.11 19.2309 25.7838 19.7247 26.1358L25.7846 30.4757C25.9716 30.6123 26.205 30.6454 26.4468 30.5904L33.7909 28.3954C34.3735 28.2031 34.9028 28.7527 34.7004 29.3428L32.1816 36.4172C32.0889 36.6241 32.1392 36.8581 32.2651 37.0616L36.5048 43.1092C36.8387 43.6105 36.4849 44.2615 35.8667 44.2562L28.2218 44.2839C28.0032 44.2872 27.7382 44.394 27.5929 44.5796L22.8695 50.5502C22.4948 51.0401 21.7422 50.9195 21.5598 50.3573L19.3815 43.3099C19.2934 43.0912 19.1295 42.9029 18.9341 42.8545L11.7749 40.483C11.2116 40.2861 11.0987 39.5687 11.6078 39.1942L17.8899 34.7994C18.1024 34.6715 18.1951 34.4647 18.2206 34.2001L18.5047 26.7119Z",
    fill: "#FFC71B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73 41.962C20.5267 41.2387 19.9448 40.6679 19.2386 40.4438L13.8072 38.6478L18.585 35.3251C19.2077 34.9047 19.6226 34.1868 19.6611 33.4084L19.8953 27.7626L24.4885 31.0828C25.1021 31.5137 25.9072 31.6556 26.6559 31.4388L32.2229 29.7477L30.288 35.1038C30.0393 35.7972 30.1437 36.6027 30.5741 37.2345L33.7891 41.8302L27.9839 41.8375C27.6749 41.8348 27.3426 41.8839 27.0397 42.0058C26.6233 42.1736 26.2509 42.4507 25.9836 42.7702L22.3989 47.3075L20.73 41.962Z",
    fill: "url(#paint2_linear_17108_263524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17108_263524",
    x1: 58.0298,
    y1: 44.6579,
    x2: 49.6088,
    y2: 30.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17108_263524",
    x1: 44.2049,
    y1: 50.4491,
    x2: 45.193,
    y2: 31.5911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0167598,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17108_263524",
    x1: 22.5665,
    y1: 54.9153,
    x2: 23.7204,
    y2: 32.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3986,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantLogo);
export default __webpack_public_path__ + "static/media/assistant-logo.e60a08256b837b5847f5d6e0bc0f90bf.svg";
export { ForwardRef as ReactComponent };